export default __webpack_public_path__ + "static/media/ens-logo.19559e18.svg";